import { render, staticRenderFns } from "./renderCategory.vue?vue&type=template&id=241c2304&scoped=true"
import script from "./renderCategory.vue?vue&type=script&lang=js"
export * from "./renderCategory.vue?vue&type=script&lang=js"
import style0 from "./renderCategory.vue?vue&type=style&index=0&id=241c2304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c2304",
  null
  
)

export default component.exports